import type React from 'react'

export type RenderErrorsProps = {
  errors?: Array<string | React.ReactNode>
}

export function RenderErrors({ errors }: RenderErrorsProps) {
  if (!errors || errors.length === 0) return null
  return (
    <div>
      {errors.map(err => (
        <div key={typeof err === 'string' ? err : String(err)}>{err}</div>
      ))}
    </div>
  )
}
